import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy
} from '@angular/core';

/**
 * Sets aria-label on the copy button inside nz-typography[nzCopyable] for screen readers.
 */
@Directive({
  selector: '[appCopyButtonAriaLabel]',
  standalone: false
})
export class CopyButtonAriaLabelDirective implements AfterViewInit, OnDestroy {
  @Input() appCopyButtonAriaLabel = 'Copy to clipboard';

  private copyButton: HTMLButtonElement | null = null;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.updateCopyButtonLabel();
  }

  ngOnDestroy(): void {
    this.copyButton = null;
  }

  private updateCopyButtonLabel(): void {
    const label = this.appCopyButtonAriaLabel?.trim();
    if (!label) return;
    // Copy button is rendered by nz-typography; may appear after view init
    const findAndLabel = (): void => {
      const button = this.el.nativeElement.querySelector?.('.ant-typography-copy');
      if (button instanceof HTMLButtonElement) {
        this.copyButton = button;
        button.setAttribute('aria-label', label);
      }
    };
    findAndLabel();
    setTimeout(findAndLabel, 100);
  }
}
